import styled from '@emotion/styled';
import { Radio, RadioProps } from '@mui/material';

const BpIcon = styled('span')<{ bgColor?: string }>`
    border-radius: 50%;
    width: 24px;
    height: 24px;
    box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 -1px 0 rgba(16, 22, 26, 0.1);
    background-color: #f5f8fa;
    background-image: linear-gradient(180deg, hsla(0, 0%, 100%, 0.1), hsla(0, 0%, 100%, 0));
    &:before {
        display: block;
        width: 24px;
        height: 24px;
        background-image: radial-gradient(#fff, #fff 28%, transparent 32%);
        content: '';
    }
    input:hover ~ & {
        background-color: ${(props) => (props.bgColor ? props.bgColor : '#137cbd')};
    }
    input:disabled ~ & {
        box-shadow: none;
        background: rgba(206, 217, 224, 0.5);
    }
`;

const BpCheckedIcon = styled(BpIcon)<{ bgColor?: string }>`
    background-color: ${(props) => (props.bgColor ? props.bgColor : '#137cbd')};
    background-image: linear-gradient(180deg, hsla(0, 0%, 100%, 0.1), hsla(0, 0%, 100%, 0));
    &:before {
        display: block;
        width: 24px;
        height: 24px;
        background-image: radial-gradient(#fff, #fff 28%, transparent 32%);
        content: '';
    }
    input:hover ~ & {
        background-color: ${(props) => (props.bgColor ? props.bgColor : '#137cbd')};
    }
`;

export interface CustomRadioProps extends RadioProps {
    bgColor?: string;
    checkedColor?: string;
}

export function BpRadio(props: CustomRadioProps) {
    return (
        <Radio
            sx={{
                paddingRight: 0,
                '&:hover': {
                    bgcolor: 'transparent'
                }
            }}
            disableRipple
            color="default"
            checkedIcon={<BpCheckedIcon bgColor={props.bgColor} />}
            icon={<BpIcon bgColor={props.checkedColor} />}
            {...props}
        />
    );
}

export const OnCallContainer = styled('div')`
    border-radius: 12px;
    border: 4px solid #f5f5f5;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.02);
    max-width: 190px;

    .optionsContainer {
        visibility: hidden;
        opacity: 0;
        height: 0;
        margin: 0;
        padding: 0 16px;
        overflow: hidden;
        transition: opacity 1s ease-in-out, height 1s ease-in-out, visibility 1s ease-out;

        &__option {
            display: flex;
            width: 100%;
            justify-content: space-between;
            margin-left: 0;
            transition: all 0.25s ease;

            &.invisible {
                display: none;
            }

            &:hover {
                border-radius: 10px;
            }
        }

        &--show {
            margin-top: -9px;
            visibility: visible;
            opacity: 1;
            height: auto;

            &.onIntake {
                opacity: 0;
                visibility: hidden;
                height: 0;
                margin-top: 0;
            }
        }
    }
`;
